import { render, staticRenderFns } from "./echartdetail.vue?vue&type=template&id=28a3bae2&"
import script from "./echartdetail.vue?vue&type=script&lang=js&"
export * from "./echartdetail.vue?vue&type=script&lang=js&"
import style0 from "./echartdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports